// App.tsx
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import AdminLayout from './components/AdminLayout'
import Admin from './pages/AdminPage'
import LoginPage from './pages/Login'
import PrintEtiqueta from './pages/PrintEtiqueta'
import CSVImportPage from './pages/admin/CSVImportPage'
import AccessListPage from './pages/admin/AccessListPage'
import RegistrationListPage from './pages/admin/RegistrationListPage'
import ReportsHubPage from './pages/admin/ReportsHubPage'
import TerminalLinksPage from './pages/admin/TerminalLinksPage'

const App: React.FC = () => {
  return (
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/csv-import"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CSVImportPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/terminais"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <TerminalLinksPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/access-list"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AccessListPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/registration-list"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <RegistrationListPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/relatorios"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ReportsHubPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/impressao"
          element={
            <ProtectedRoute>
              <PrintEtiqueta />
            </ProtectedRoute>
          }
        />
      </Routes>
  );
};

export default App;
